var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"editor",staticClass:"editor",staticStyle:{"height":"200px"},style:(_vm.styles)}),_c('el-upload',{ref:"upload",staticStyle:{"display":"none"},attrs:{"name":"file","headers":_vm.headers,"action":_vm.action,"on-success":_vm.onFileChange,"limit":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }